import { HrefLink } from '@bloomays-lib/ui.shared';
import { EmotionJSX } from '@emotion/react/types/jsx-namespace';
import { styled } from '@mui/material/styles';

export type ToastProps = {
  text: string | React.ReactNode | React.JSX.Element | EmotionJSX.Element;
  link?: string;
  error?: any;
};

const Toast = ({ text, link, error }: ToastProps) => {
  return (
    <ToastContent>
      {text}
      {error ? (
        <>
          <br />
          <i>{error.toString()}</i>
        </>
      ) : undefined}
      {link ? (
        <HrefLink
          text="👉 Cliquez ici"
          href={link}
          target={link.includes('https://') ? '_blank' : '_self'}
          sx={{
            textDecoration: 'none',
            fontWeight: 'bold',
          }}
        />
      ) : undefined}
    </ToastContent>
  ) as React.ReactNode;
};

const ToastContent = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
}));

export default Toast;
export { Toast };
